import login from './login/login_pt'
import forgotPassword from './forgotPassword/forgotPassword_pt'
import changePassword from './changePassword/changePassword_pt'
import termsAndConditions from './termsAndConditions/termsAndConditions_pt'
import updatePassword from './updatePassword/updatePassword_pt';
import settlements from './settlements/settlements_pt';
import createSettlement from './settlements/create-settlement/create-settlement_pt';
import filters from './filters/filters_pt'
import settlementDetail from './settlements/settlement-detail_pt'
import rcm from './rcm/home/rcmHome_pt';
import rcmAccountDetail from './rcm/account-detail/account-detail_pt'
import rcmChargeDetail from './rcm/charge-detail/charge-detail_pt'
import supportsAdministrator from './rcm/support-administrator/support-administrator_pt'
import rcmAgreements from './rcm/agreements/agreements_pt'
import commentsRcm from './rcm/comments/comments_pt'
import preSettlements from './rcm/pre-settlements/pre-settlements_pt'
import rcmProducts from './rcm/products-configuration/ProductsConfiguration_pt'
import rcmUploadAgreementMatrix from './rcm/upload-agreement-matrix/UploadAgreementMatrix_pt'
import tfa from './tfa/tfa_pt'
import home from './home/home_pt'
import aiValidationDetail from './rcm/ai-validation-detail/ai-validation-detail_pt'

const portugueseMessages = {
    globalErrorUnknown: 'Tivemos um problema técnico! Tente novamente ou entre em contato com sua equipe de suporte técnico.',
    loading: 'Carregando',
    errorTitle: 'ocorreu um erro',
    defaultErrorDescription: 'Por favor, Entre em contato com a equipe de suporte técnico para obter mais informações.',
    badCredentials: 'Credenciais erradas! Por favor, tente novamente.',
    searchMatches: 'correspondências de pesquisa',
    buttons: {
        close: 'Fechar',
        save: 'Salvar',
        delete: 'Eliminar',
        cancel: 'Cancelar',
        accept: 'Aceitar',
        add: 'Adicionar',
        search: 'Pesquisar',
    },
    errors: {
        inputValidations: {
            invalidNIT: "As informações introduzidas em {fieldName} não estão em conformidade com os parâmetros. Por favor, verifique e corrija os dados.",
            required: 'Obrigatório',
            invalidFormat: 'O formato está incorreto',
            maxLength: 'O limite de {n} caracteres foi excedido',
            minLength: 'Mínimo {n} caracteres',
            dynamicFieldInvalidFormat: 'O formato está incorreto'
        },
        authorizationRequest: {
            emptyAuthorization: 'A criação da autorização falhou, entre em contato com a equipe de suporte para obter mais informações.',
        },
        dispensingRequest: {
            emptyApprovedProducts: 'Nenhum produto foi aprovado para esta autorização. Entre em contato com a equipe de suporte para obter mais informações.',
        },
        voidAuthorizations: {
            success: 'A autorização foi anulada com sucesso.',
        }
    },
    drawer: {
        logout: 'Fechar sessão',
    },
    footer: {
        privacyLabel: 'Privacidade',
    },
    locales: {
        'es-DO': 'Espanhol',
        es: 'Espanhol',
        en: 'Inglês',
        pt: 'Português'
    },
    identityDocumentTypes: {
        passport: 'Passaporte',
        nationalIdentityCard: 'Número de identificação nacional',
        socialSecurityNumber: 'Número do seguro social',
        taxIdentificationNumber: 'Número de identificação Tributária',
        electoralRegistryNumber: 'Número de identificação eleitoral',
    },
    genders: {
        male: 'Homem',
        female: 'Mulheres',
    },
    posology: {
        day: 'dia | dias',
        unit: 'unidade | unidades',
        medicalDeviceDescription: 'Use {0} ({1}) {2} para {3} ({4}) {5}',
        half: 'médio',
        quarter: 'um quarto | {value} trimestres',
        andConnector: 'e',
        pointConnector: 'ver',
    },
    sponsors: {
        umbrella: 'Umbrella Osigu ARS',
        humano: 'Seguro Humano',
        universal: 'ARS universal',
        primera: 'ARS Primeira',
        humanoCategories: {
            global: 'Global',
            platinum: 'Platina',
            conventional: 'Convencional',
        }
    },
    voidAuthorization: {
        back: 'Volte',
        confirm: 'Sim, cancelar',
        title: 'Cancelar autorização',
        titleOnlyClaim: 'Cancelar reivindicação',
        hint: 'Confirme para cancelar esta autorização. Esta ação não pode ser revertida.',
        hintOnlyClaim: 'Confirme para anular esta reivindicação. Esta ação não pode ser revertida.',
    },
    actions: {
        upload: 'Carregar',
        delete: 'Eliminar',
        replace: 'Substituir',
        view: 'Visualizar',
        attention: 'Atenção',
        download: 'Baixar',
        edit: 'Editar',
    },
    yes: 'Sim',
    no: 'Não',
    supportFileUploadSuccess: 'Documento carregado com sucesso. Em alguns minutos estará disponível no Filezilla.',
    supportFileUploadSuccessBR: 'Documento carregado com sucesso. Em alguns minutos sua analise estará pronta.',
    supportFileDeleteSuccess: 'O arquivo foi excluído com sucesso',
    supportFileRestrictedAsAccountLevel: 'Obrigatório no nível da conta',
    emptyResults: 'nenhum resultado encontrado',
    cancelFormButton: 'Cancelar',
    chronicTreatmentLabel: 'Tratamento crônico',
    errorLoadingFile: 'Ocorreu um erro ao enviar o arquivo. Tente novamente ou entre em contato com a equipe de suporte técnico.',
    informationSuccessfullyUpdated: 'Informação atualizada com sucesso',
    ProtectedFile: 'O documento associado ao {supports} está protegido, por favor habilite sua leitura.',
    invalidFileType: 'Tipo de arquivo inválido, tipos de arquivo permitidos: PNG, JPEG, XML, PDF',
    errorEmailNotRegistered: 'O e-mail informado não está registrado. Por favor, verifique se o endereço está correto e tente novamente.',
    login,
    forgotPassword,
    changePassword,
    termsAndConditions,
    updatePassword,
    settlements,
    filters,
    settlementDetail,
    createSettlement,
    rcm,
    rcmAccountDetail,
    rcmChargeDetail,
    supportsAdministrator,
    rcmAgreements,
    commentsRcm,
    preSettlements,
    rcmProducts,
    rcmUploadAgreementMatrix,
    tfa,
    home,
    aiValidationDetail
}

export default portugueseMessages